export default "__VITE_ASSET__24f0e671__"